import React, {useState} from "react";
import Input from "../../../../../app/components/Input";
import Select from "../../../../../app/components/Select";
import Button from "../../../../../app/components/Button";
import Table from "../../../../../app/components/Table";

const Audit = () => {
    const optionsAcoes = [
        {value: 'todas', label: 'Todas'},
        {value: 'login', label: 'Login'},
        {value: 'logout', label: 'Logout'},
        {value: 'criar', label: 'Criar'},
        {value: 'atualizar', label: 'Atualizar'},
        {value: 'excluir', label: 'Excluir'},
    ]

    const columnsAudit = [
        { campo: 'data', titulo: 'Data/hora' },
        { campo: 'usuario', titulo: 'Usuário' },
        { campo: 'acao', titulo: 'Ação' },
        { campo: 'descricao', titulo: 'Descrição' },
        { campo: 'ip', titulo: 'IP' },
    ];

    const [actionData, setActionData] = useState({
        acao: '',
    });
    
    const [dataAudit, setDataAudit] = useState([
    ]);

    const handleChange = (e) => {
        setActionData((prev) => ({
        ...prev,
        [e.target.name]: e.target.value,
        }));
    };
    
    return(
        <div className="pt-4">
            <h2 class="text-lg font-medium text-gray-900 mb-8">Log de Auditoria</h2>
            <div className="flex gap-4 item-center">
                <Input
                    label='Data Início'
                    type="date"
                />
                <Input
                    label='Data Fim:'
                    type="date"
                />
                <Select
                    label='Ação'
                    name="acao"
                    value={actionData.acao}
                    onChange={handleChange}
                    options={optionsAcoes}
                />
                <Button className="w-40 h-12">Filtrar</Button>
            </div>
            {dataAudit.length === 0 ? (
                <div className="text-center text-sm text-gray-500 py-8 font-medium">
                    Nenhum registro encontrado.
                </div>
            ) : (
                <div>
                    <Table
                        colunas={columnsAudit}
                        dados={dataAudit}
                    />
                    <Button className="mt-4" variant="primary">Exportar</Button>
                </div>
            )}
        </div>
    )
}

export default Audit